import { Directive, ViewContainerRef } from '@angular/core';

@Directive({
  selector: '[bottomSheetHost]',
})
export class BottomSheetHostDirective {
  constructor(public viewContainerRef: ViewContainerRef) {
  }
}
